/**
 * /album-manage — the screen a standalone-album buyer lands on after checkout.
 *
 * This file is only the CHROME: sign-in state, and the picker shown when there
 * is no ?id=. Everything inside the album itself is dashboard-album.js, which
 * carries its own translations keyed off <html lang> — so a localized page gets
 * a localized album tab for free, and there is no second copy of that UI here.
 *
 * Localized pages emit window.__AM_I18N ahead of this script (see
 * scripts/build-album-manage-locales.js); English falls through to the
 * defaults below, which is why there is one copy of this file rather than seven.
 */
(function () {
    'use strict';

    const T = Object.assign({
        payPill: 'Payment needed',
        pickError: "Couldn't load your albums. Please refresh.",
        photos: 'photos',
        signInReason: 'opening your photo album'
    }, window.__AM_I18N || {});

    const albumId = new URLSearchParams(location.search).get('id');
    const signedOut = document.getElementById('signedOut');
    const wrap = document.getElementById('albumWrap');
    const picker = document.getElementById('picker');

    // Keep the locale the visitor is already in when we send them onward.
    const localePrefix = (location.pathname.match(/^\/(es|fr|de|pt|he|ar)\//) || [])[1];
    const loc = localePrefix ? '/' + localePrefix : '';

    const signInBtn = document.getElementById('signInBtn');
    if (signInBtn) {
        signInBtn.addEventListener('click', function () {
            try { window.authModal.show(T.signInReason); } catch (e) { /* no modal */ }
        });
    }

    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
        });
    }

    /**
     * No ?id= means "show me my albums" rather than a dead end: someone who
     * bought an album and closed the tab has nothing but their receipt
     * otherwise. Event albums are filtered out — those live in their own
     * dashboard tab, and sending a host here would split the surface in two.
     */
    async function showPicker(user) {
        picker.style.display = '';
        const list = document.getElementById('pickerList');
        try {
            const token = await user.getIdToken();
            const res = await fetch('/api/albums/mine', { headers: { Authorization: 'Bearer ' + token } });
            const data = await res.json();
            const albums = (data.albums || []).filter(function (a) { return a.standalone; });
            if (!albums.length) {
                document.getElementById('pickerEmpty').style.display = '';
                return;
            }
            list.innerHTML = albums.map(function (a) {
                const when = a.eventDate
                    ? new Date(a.eventDate + 'T00:00:00').toLocaleDateString(
                        document.documentElement.lang || undefined,
                        { year: 'numeric', month: 'short', day: 'numeric' })
                    : '';
                const pill = a.isPaid ? '' : '<span class="pay-pill">' + esc(T.payPill) + '</span>';
                return '<a class="album-row" href="' + loc + '/album-manage?id=' + encodeURIComponent(a.id) + '">'
                    + '<span><strong>' + esc(a.title) + '</strong>'
                    + '<span class="meta d-block">' + esc(when)
                    + (a.photoCount ? ' &middot; ' + a.photoCount + ' ' + esc(T.photos) : '') + '</span></span>'
                    + pill + '</a>';
            }).join('');
        } catch (err) {
            list.innerHTML = '<p class="text-muted">' + esc(T.pickError) + '</p>';
        }
    }

    firebase.auth().onAuthStateChanged(function (user) {
        if (!user) {
            signedOut.style.display = '';
            wrap.style.display = 'none';
            picker.style.display = 'none';
            return;
        }
        signedOut.style.display = 'none';
        if (!albumId) {
            showPicker(user);
            return;
        }
        wrap.style.display = '';
        window.dashboardAlbum.initById(albumId);
    });
})();
